/* Copyright 2013 - 2024 Waiterio LLC */
import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client' // eslint-disable-line import/extensions
import { BrowserRouter } from 'react-router'
import { initMultilocale } from '@multilocale/react/index.jsx'
import SupoviaProvider from '@supovia/react/SupoviaProvider.jsx'
import StageBadge from '@waiterio/components/StageBadge.jsx'
import ErrorBoundary from '@waiterio/components/ErrorBoundary.jsx'
import ReferrerCookie from '@waiterio/components/ReferrerCookie.js'
import ScrollToTop from '@waiterio/components/ScrollToTop.jsx'
import getSentryBrowser from '@monorepool/telemetry/getSentryBrowser.js'
import GlobalStyles from './styles/GlobalStyles.jsx'
import Routes from './Routes.jsx'

initMultilocale({
  organizationId: 'e395dba6a14d8af4c2d35890',
  project: 'waiterio-docs',
})

createRoot(document.getElementById('root')).render(
  <ErrorBoundary>
    <BrowserRouter>
      <SupoviaProvider>
        <Suspense>
          <ScrollToTop />
          <GlobalStyles />
          <Routes />
          <ReferrerCookie />
          <StageBadge />
        </Suspense>
      </SupoviaProvider>
    </BrowserRouter>
  </ErrorBoundary>,
)

getSentryBrowser()
